// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3wU-v","title":"card_title__Ke-NP","inActive":"card_inActive__24pX1"};